import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import { Alarm } from "../models/alarm";
import { AlarmLevelPipe } from "./alarm-level.pipe";
import { AlarmTypePipe } from "./alarm-type.pipe";


@Pipe({
    name: 'alarmToStringPipe'
})

export class AlarmToStringPipe implements PipeTransform {

    
    transform(alarm: Alarm): string {

    var datePipe = new DatePipe('en-ZA')
    var alarmLevelPipe = new AlarmLevelPipe();
    var alarmType = new AlarmTypePipe();

        var label: string;

        if(alarm && alarm.port)
            label = alarm.port.port_label;
        else if(alarm && alarm.device) //TODO: add device to model
            label = alarm.device.dev_label;

        if(alarm)
        return alarmLevelPipe.transform(alarm.alarm_level) + " on " + 
        label + ", " + alarmType.transform(alarm.alarm_type) + 
        " at " + datePipe.transform(alarm.alarm_created, 'HH:mm - dd/MM/yy').toString()
    }
}